module.exports = __webpack_public_path__ + "img/monitorbox30.e89e7869.jpg";